import { get, min, max } from 'lodash'

export const updateMiniCartCount = cart => {
  const miniCarts = document.getElementsByClassName('cart_count')
  const hiddenProducts = document.querySelector('meta[name="hidden-products"]').content.split(',')

  for (let i = 0; i < miniCarts.length; i++) {
    miniCarts.item(i).innerText = cart.items.reduce((acc, current) => {
      if (current.product_type === 'freebie' && hiddenProducts.includes(current.sku)) return acc
      acc = acc + current.quantity
      return acc
    }, 0)
  }
}

export const getCartType = (cartItems) => {
  /* global Shopify */

  const hasSubscription = cartItems.some(item => item.sku.includes('BUNDLE.C'))
  const hasWomenProduct = cartItems.some(item => ['women care', 'napkin', 'skin care', 'supplement'].includes(item.product_category))
  const hasBabyProduct = cartItems.some(item => ['wipe', 'swaddle', 'baby care', 'care', 'box'].includes(item.product_category))
  const hasKidsProduct = cartItems.some(item => item.product_category === 'kids')
  const hasSpecialProduct = cartItems?.some(item => item.upsell_categories?.includes('special'))

  if (!hasSubscription && hasSpecialProduct && Shopify.locale === 'fr') {
    return 'SPECIAL'
  }

  if (hasSubscription) {
    return 'BUNDLE'
  } else if (hasKidsProduct && hasWomenProduct) {
    return 'MIX'
  } else if (hasBabyProduct) {
    return 'BABY'
  } else if (hasWomenProduct) {
    return 'WOMEN'
  } else if (hasKidsProduct) {
    return 'KIDS'
  } else {
    return 'MIX'
  }
}

export const retrieveRecommendedProducts = (currentProduct, products) => {
  const settings = document.querySelector('meta[name="incentive-cart-recommended-products"]').content

  if (!settings) return

  let recommendedProducts = []
  const settingsList = settings.split(';\n')
  for (let i = 0; i < settingsList.length; i++) {
    const element = settingsList[i]

    if (element) {
      const initialSku = element.split('|')[0]
      const productList = element.split('|')[1]
      const regex = new RegExp(initialSku)

      if (regex.test(currentProduct.sku)) {
        recommendedProducts = productList.split(',')
      }
    }
  }

  const getOptionsFromProduct = product => Object.entries(product).filter(([key, value]) => key.includes('option'))

  const fullRecommendedProducts = recommendedProducts.map(productSku => {
    let currentProductVariant = currentProduct.options_with_values?.find(option => option.name === 'Imprimé')?.value
    if (!currentProductVariant) currentProductVariant = 'Malo'
    let currentProductSize = currentProduct.options_with_values?.find(option => option.name === 'Taille')?.value.split('-')[0]
    if (!currentProductSize) currentProductSize = 'T3'

    const regex = new RegExp('^' + productSku, 'i')
    const matchingProducts = products.filter(product => regex.test(product.sku))

    if (matchingProducts.length === 1) {
      return matchingProducts[0]
    } else {
      const matchingProduct = matchingProducts.find(matchingProduct => {
        if (productSku.includes('*') && !productSku.includes('*.*')) {
          return getOptionsFromProduct(matchingProduct).find(option => option[1] && option[1].includes(currentProductVariant))
        } else if (productSku.includes('*.*')) {
          return getOptionsFromProduct(matchingProduct).find(option => option[1] && option[1].includes(currentProductVariant)) &&
          getOptionsFromProduct(matchingProduct).find(option => option[1] && option[1].includes(currentProductSize))
        }
      })
      return matchingProduct || matchingProducts[0]
    }
  })

  return fullRecommendedProducts.filter(p => p).slice(0, 4)
}

export const retrieveProducts = (cart, products, settings) => {
  if (!settings) return
  /* global Shopify */

  const cartItems = get(cart, 'items', []).map(item => products.length && products.find(p => p.sku === item.sku)).filter(p => p)
  if (cartItems?.length === 0) return

  const hasSubscription = cartItems.some(item => item.sku.includes('BUNDLE.C'))
  const hasWomenProduct = cartItems.some(item => ['women care', 'napkin', 'skin care', 'supplement'].includes(item.product_category))
  const hasBabyProduct = cartItems.some(item => ['wipe', 'swaddle', 'baby care', 'care', 'box'].includes(item.product_category))
  const hasKidsProduct = cartItems.some(item => item.product_category === 'kids')

  const productsSettings = settings.split(';\n')
  const babyProducts = productsSettings.find(productsSetting => productsSetting.includes('BABY'))?.split('|')[1]?.split(',')
  const womenProducts = productsSettings.find(productsSetting => productsSetting.includes('WOMEN')).split('|')[1].split(',')
  const mixProducts = productsSettings.find(productsSetting => productsSetting.includes('MIX')).split('|')[1].split(',')
  const kidsProducts = productsSettings.find(productsSetting => productsSetting.includes('KIDS')).split('|')[1].split(',')
  // If we want more than one gift on the incentive cart, for example with 3 gifts for bundles:
  // const subscriptionProducts = productsSettings.find(productsSetting => productsSetting.includes('BUNDLE'))?.split('|').slice(-3)
  const subscriptionProducts = productsSettings.find(productsSetting => productsSetting.includes('BUNDLE'))?.split('|')[1].split(',')
  const hasSpecialProduct = cartItems?.some(item => item.upsell_categories?.includes('special'))
  const specialsProduct = productsSettings.find(productsSettings => productsSettings.includes('SPECIALS'))?.split('|')[1].split(',')

  if (!hasSubscription && hasSpecialProduct && specialsProduct && Shopify.locale === 'fr') {
    return specialsProduct
  }

  if (hasSubscription) {
    if (subscriptionProducts) {
      return subscriptionProducts
    } else {
      if (hasWomenProduct) {
        return womenProducts
      } else {
        return babyProducts
      }
    }
  } else if (hasKidsProduct && hasWomenProduct) {
    return mixProducts
  } else if (hasBabyProduct) {
    return babyProducts
  } else if (hasWomenProduct) {
    return womenProducts
  } else if (hasKidsProduct) {
    return kidsProducts
  } else {
    return mixProducts
  }
}

export const calculatePriceDifference = (threshold, total) =>
  (Number(threshold) - Number(total)) / 100 > 0
    ? (Number(threshold) - Number(total)) / 100
    : 0

export const calculateThresholds = (cart, shippingThresholds, freeGiftsSelectionAvailable, secondStepGiftsAvailable) => {
  let progressBarMax, priceDifferenceGift, priceDifferenceShipping, percentage, currentShippingThreshold

  // while free-products-threshold is empty in the theme it won't be activated
  const freeProductsThreshold = Number(document.querySelector('meta[name="free-products-threshold"]').content) > 0 ? Number(document.querySelector('meta[name="free-products-threshold"]').content) : null
  const secondFreeProductsThreshold = Number(document.querySelector('meta[name="second_step_free_products_threshold"]').content) ?? null

  if (shippingThresholds) {
    if (cart?.items) {
      currentShippingThreshold = min(shippingThresholds.filter(setting => {
        const sku = setting.split('|')[0]
        if (sku === 'all' || cart.items.find(item => item.sku === sku)) return setting
      }).map(setting => Number(setting.split('|')[1])))
    }

    progressBarMax = currentShippingThreshold

    if ((freeGiftsSelectionAvailable || cart?.items?.find(item => item.sku.includes('BUNDLE.C'))) && freeProductsThreshold) {
      if (secondStepGiftsAvailable) {
        progressBarMax = max([freeProductsThreshold, currentShippingThreshold, secondFreeProductsThreshold])
      } else {
        progressBarMax = max([freeProductsThreshold, currentShippingThreshold])
      }
      priceDifferenceGift = calculatePriceDifference(freeProductsThreshold, cart.total_price)
    }

    let progressBarThresholds = [currentShippingThreshold]
    freeGiftsSelectionAvailable && progressBarThresholds.push(freeProductsThreshold)
    secondStepGiftsAvailable && progressBarThresholds.push(secondFreeProductsThreshold)

    progressBarThresholds = progressBarThresholds.filter(value => value && value > 0)

    percentage = isNaN(Number(cart.total_price * 100 / Number(progressBarMax)))
      ? 0
      : Math.round(Number(cart.total_price * 100 / Number(progressBarMax))) > 100
        ? 100
        : percentageCompletion(cart.total_price, progressBarThresholds)

    if (cart.total_price >= freeProductsThreshold) {
      if (secondStepGiftsAvailable) {
        priceDifferenceShipping = calculatePriceDifference(secondFreeProductsThreshold, cart.total_price)
      } else {
        priceDifferenceShipping = 0
      }
    } else {
      priceDifferenceShipping = calculatePriceDifference(currentShippingThreshold, cart.total_price)
    }
  }

  return {
    percentage,
    priceDifferenceGift,
    priceDifferenceShipping,
    currentShippingThreshold,
    freeProductsThreshold,
    secondFreeProductsThreshold,
    progressBarMax
  }
}

const percentageCompletion = (totalPrice, progressBarThresholds) => {
  const sortedThresholds = progressBarThresholds.sort()
  const nextThresholdIndex = sortedThresholds.findIndex(threshold => threshold > totalPrice)
  const completedStepsCount = nextThresholdIndex > 0
    ? nextThresholdIndex + 1
    : 0
  const stepCount = sortedThresholds.length
  const stepPercentageCompleted = completedStepsCount > 0
    ? Math.round(Number(completedStepsCount * (100 / stepCount)))
    : 0
  const completion = completedStepsCount > 0
    ? stepPercentageCompleted + Math.round(Number(((totalPrice - sortedThresholds[nextThresholdIndex]) * sortedThresholds[nextThresholdIndex]) / 1000000))
    : stepPercentageCompleted + totalPrice / sortedThresholds[nextThresholdIndex] * (100 / stepCount)

  return completion
}

/**
 * Used to find the current step of progress bar in cart
 * @param price
 * @return {boolean}
 */
export const isFirstStep = price => {
  const thresholdFirstStep = Number(document.querySelector('meta[name="free-products-threshold"]').content) ?? undefined
  const thresholdSecondStep = Number(document.querySelector('meta[name="second_step_free_products_threshold"]').content) ?? undefined

  if (!thresholdFirstStep && !thresholdSecondStep) return false

  return price >= thresholdFirstStep && price < thresholdSecondStep
}

/**
 * Used to find the current step of progress bar in cart
 * @param price
 * @return {boolean}
 */
export const isSecondStep = (price, secondStepGiftsAvailable) => {
  const thresholdSecondStep = Number(document.querySelector('meta[name="second_step_free_products_threshold"]').content) ?? undefined

  if (!thresholdSecondStep || !secondStepGiftsAvailable) return false

  return price >= thresholdSecondStep
}

export function isSettingsMissing () {
  const settings = [
    Number(document.querySelector('meta[name="free-products-threshold"]').content) ?? undefined,
    Number(document.querySelector('meta[name="second_step_free_products_threshold"]').content) ?? undefined
  ]

  if (settings.some(settings => !settings)) {
    console.log('%cError: settings is missing', 'color: orange;', ' (incentive cart)')
  }
}

/**
 * In some cases we want to remove all gifts in cart.
 * Example: user have one-off items and he selected 2 gifts, and then he add a
 * bundle subscription in his cart. In this case we want to remove all gifts.
 * @param items
 * @param dispatch
 * @param updateCart
 */
export async function removeAllGifts (items = [], dispatch, updateCart) {
  const shopUrl = document.querySelector('meta[name="shop-url"]').content
  const toRemove = items?.reduce((acc, current) => {
    if (current.product_type === 'freebie') {
      acc[current.variant_id || current.shopify_variant_id] = 0
    }

    return acc
  }, {})

  await fetch(`${shopUrl}/cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: toRemove })
  })
}

export function metaGiftOverride (variantsList, setSecondStepGiftsAvailable, setFreeGiftsSelectionAvailable) {
  const firstStepMeta = document.querySelector('meta[name="gifts"]')
  const secondStepMeta = document.querySelector('meta[name="gifts-second-step"]')
  const steps = Object.entries([firstStepMeta, secondStepMeta])
  const secondStepThreshold = Number(document.querySelector('meta[name="second_step_free_products_threshold"]').content) > 0

  for (const [index, meta] of steps) {
    const metaGiftTypesSkus = meta?.content
    if (!metaGiftTypesSkus) return

    const typesSkusLines = metaGiftTypesSkus.split(';\n')

    let originalTypesSkus = {}
    for (const typeSkusLine of typesSkusLines) {
      const [type, giftSkus] = typeSkusLine.split('|')
      originalTypesSkus[type] = giftSkus?.split(',')
    }
    let typesSkus = Object.assign({}, originalTypesSkus)
    // bundle gift, a price + discount
    delete typesSkus['BUNDLE']
    // specials behavior
    delete typesSkus['SPECIALS']

    let giftSkus = Object.values(typesSkus).flat()
    giftSkus = [...new Set(giftSkus)] // remove duplicates

    const variants = variantsList['variants']
    const availableGifts = {}
    const isGift = (variant) => variant.price === '0.00'

    for (const variant of variants) {
      if (giftSkus.includes(variant.sku) && isGift(variant)) {
        availableGifts[variant.sku] = variant
      }
    }

    const types = Object.keys(typesSkus)

    const cartTypesWithoutAvailableGifts = []
    let unprocessableGifts = null
    for (const type of types) {
      const cartTypeHasGiftAvailable = typesSkus[type].find(sku => availableGifts[sku] !== undefined)

      if (!cartTypeHasGiftAvailable) {
        const firstAvailableGiftSku = Object.keys(availableGifts)[0]
        const firstAvailableGiftAmongstTypes = availableGifts[firstAvailableGiftSku]
        const secondStep = index === '1'

        if (!firstAvailableGiftAmongstTypes) {
          const firstStep = index === '0'

          if (firstStep) {
            unprocessableGifts = true

            setFreeGiftsSelectionAvailable(false)
            break
          }

          if (secondStep) {
            unprocessableGifts = true

            setSecondStepGiftsAvailable(false)
            break
          }
        }

        if (secondStep && !secondStepThreshold) {
          setSecondStepGiftsAvailable(false)
          break
        }

        originalTypesSkus[type].push(firstAvailableGiftAmongstTypes.sku)
        cartTypesWithoutAvailableGifts.push(type)
      }
    }

    if (unprocessableGifts) return

    let metaOverrided = []
    for (const type of Object.keys(originalTypesSkus)) {
      metaOverrided.push(`${type}|${originalTypesSkus[type]}`)
    }

    meta.content = metaOverrided.join(';\n')
  }
}
